var common = require("../../utiles/common.js");

module.exports = function () {
  //Windows CP自动登录
  var intervalObj = null; //计时器
  var i = 0;
  //启动计时器函数
  function startCheck() {
    if (intervalObj != null) {
      clearInterval(intervalObj);
      intervalObj = null;
    }
    intervalObj = setInterval(loginCheck, 1000); //启动计时器，调用overs函数，
  }
  function jsLogin(id, url) {
    // 调用子页面
    if (
      document.getElementById(id) &&
      document.getElementById(id).contentWindow
    ) {
      document.getElementById(id).contentWindow.postMessage("main", "*");
    }
    // 监听子页面message事件
    window.addEventListener(
      "message",
      function (event) {
        if (event.data.main) {
          console.log(event.data.main);
          stopCheck();
          // 请求后台建立token
          $.ajax({
            url: url + event.data.main,
            success: function (data) {
              console.log(data);
              common.fetch("/auth/isLogin", {
                success: function (data) {
                  if (data.data) {
                    common.redirectTo("/#/appList");
                  }
                },
              });
            },
            error: function (result) {
              console.log(result);
            },
          });
        }
      },
      false
    );
  }

  function jsIEWinLogin() {
    common.fetch("/auth/isLogin", {
      success: function (data) {
        if (data.data) {
          // 结束检查
          stopCheck();
          // 如果用户已经登录则直接跳转
          common.redirectTo("/#/appList");
        } else {
          // 如果无用户会话，则循环探测6次后结束检查
          if (i > 5) {
            // 结束检查
            stopCheck();
          }
        }
      },
    });
  }
  var ua = navigator.userAgent.toLowerCase();
  var isIE = ua.indexOf("msie") > -1;
  var os = common.validataOS();
  console.log(ua);
  function loginCheck() {
    i++;
    if (isIE) {
      jsIEWinLogin();
    } else {
      if (os === "Window") {
        jsLogin("jsWinLogin", "/auth/browser/validate?serviceTicket=");
      } else if (os === "Linux") {
        jsLogin("jsPamLogin", "/auth/pam/validateToken?token=");
      }
    }
  }
  function stopCheck() {
    clearInterval(intervalObj);
    intervalObj = null;
  }
  //域登录
  var isWinLogout = sessionStorage.getItem("isWinLogout");
  if (!isWinLogout) {
    var jsPamLoginIframe =
      '<iframe id="jsPamLogin" name="jsPamLogin" src="http://127.0.0.1:26262/pam/agent/getToken" style="display: none"></iframe>';
    var jsWinLoginIframe =
      '<iframe id="jsWinLogin" name="jsWinLogin" src="http://127.0.0.1:26262/auth/sso/jsWinLogin" style="display: none"></iframe>';
    if (isIE) {
      jsWinLoginIframe =
        '<iframe id="jsWinLogin" name="jsWinLogin" src="http://127.0.0.1:26262/auth/sso/jsIEWinLogin" style="display: none"></iframe>';
    }
    if (os === "Window") {
      $("#winLoginContent").html(jsWinLoginIframe);
    } else if (os === "Linux") {
      $("#winLoginContent").html(jsPamLoginIframe);
    }

    // 启动setInterval循环检查ticket
    startCheck();
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/component/login/cpLogin.js
// module id = 103
// module chunks = 0